// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.noResultsLine {
  width: 10%;
  height: 2px;
  background-color: #888888;
  position: absolute;
  top: 50%;
  margin-top: -1px;
left: 46%;
}
.noResults {
  height: 150px;
}
.svgCircleMainValueInfo {
  margin-top: 10px;
  font-size: 15px;
}
.trendlineText { color: #adadad; font-weight: bold; font-size: 13px; }
.trendlineTextContainer {
  justify-content: center;
  align-items: center;
  flex-direction: row;
}

.compareBarIconContainer {
  margin-top: 20px;
  width: 100%;
  position:relative;
  height:50px;
}
.compareBaroverAllIcon {
  position: absolute;
  width: 50px;
  margin-left:-25px
}
.compareBarPersonalIcon {
  position: absolute;
  width: 50px;
  margin-left: -25px;
}
.compareBarContainer {
  width: 100%;
  height: 25px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  display: inline-flex;
  margin-top: 10px;
}
.compareBarLow {
  width: 50%;
  background-color: #e01300;
  height: 40px;
  justify-content: center;
  align-items: center;
}
.compareBarModerate {
  width: 30%;
  background-color: #ffbf1f;
  height: 40px;
  justify-content: center;
  align-items: center;
}
.compareBarHigh {
  width: 20%;
  background-color: #22992e;
  height: 40px;
  justify-content: center;
  align-items: center;
}
.compareBarText { color: #ffffff; font-weight: bold; margin-top: 10px; }
.compareBarLowText {
  width: 50%;
  color: #e01300;
  height: 25px;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 12px;
}
.compareBarModerateText {
  width: 30%;
  color: #ffbf1f;
  height: 25px;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 12px;
}
.compareBarHightText {
  width: 20%;
  color: #22992e;
  height: 25px;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 12px;
}

.center-insight-info{
  margin: auto;
  width: 50%;
  padding: 10px;
  justify-content: center;
  text-align: center;
}

.projectsSubTitle {
  color: '#adadad';
  font-size: 14;
  margin-bottom: 20;
  margin-top: 0;
  text-align: 'center';
}`, "",{"version":3,"sources":["webpack://./src/app/modules/questionaire/containers/components/persona-dashboard.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;AAClB,SAAS;AACT;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA,iBAAiB,cAAc,EAAE,iBAAiB,EAAE,eAAe,EAAE;AACrE;EACE,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX;AACF;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;AACA,kBAAkB,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AACvE;EACE,UAAU;EACV,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,UAAU;EACV,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,UAAU;EACV,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,oBAAoB;AACtB","sourcesContent":[".noResultsLine {\n  width: 10%;\n  height: 2px;\n  background-color: #888888;\n  position: absolute;\n  top: 50%;\n  margin-top: -1px;\nleft: 46%;\n}\n.noResults {\n  height: 150px;\n}\n.svgCircleMainValueInfo {\n  margin-top: 10px;\n  font-size: 15px;\n}\n.trendlineText { color: #adadad; font-weight: bold; font-size: 13px; }\n.trendlineTextContainer {\n  justify-content: center;\n  align-items: center;\n  flex-direction: row;\n}\n\n.compareBarIconContainer {\n  margin-top: 20px;\n  width: 100%;\n  position:relative;\n  height:50px;\n}\n.compareBaroverAllIcon {\n  position: absolute;\n  width: 50px;\n  margin-left:-25px\n}\n.compareBarPersonalIcon {\n  position: absolute;\n  width: 50px;\n  margin-left: -25px;\n}\n.compareBarContainer {\n  width: 100%;\n  height: 25px;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  display: inline-flex;\n  margin-top: 10px;\n}\n.compareBarLow {\n  width: 50%;\n  background-color: #e01300;\n  height: 40px;\n  justify-content: center;\n  align-items: center;\n}\n.compareBarModerate {\n  width: 30%;\n  background-color: #ffbf1f;\n  height: 40px;\n  justify-content: center;\n  align-items: center;\n}\n.compareBarHigh {\n  width: 20%;\n  background-color: #22992e;\n  height: 40px;\n  justify-content: center;\n  align-items: center;\n}\n.compareBarText { color: #ffffff; font-weight: bold; margin-top: 10px; }\n.compareBarLowText {\n  width: 50%;\n  color: #e01300;\n  height: 25px;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-size: 12px;\n}\n.compareBarModerateText {\n  width: 30%;\n  color: #ffbf1f;\n  height: 25px;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-size: 12px;\n}\n.compareBarHightText {\n  width: 20%;\n  color: #22992e;\n  height: 25px;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-size: 12px;\n}\n\n.center-insight-info{\n  margin: auto;\n  width: 50%;\n  padding: 10px;\n  justify-content: center;\n  text-align: center;\n}\n\n.projectsSubTitle {\n  color: '#adadad';\n  font-size: 14;\n  margin-bottom: 20;\n  margin-top: 0;\n  text-align: 'center';\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
